import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useAppContext } from '../../hooks';
import { breakpoints } from 'app/variables';
import ActionButton from '../ActionButton';
import { GoogleButton, AppleButton } from '../SocialAuthButton';

import StepHeading from './StepHeading';

const FeatureList = styled.ul`
  font-size: 1.5rem;
  list-style-type: '✓';
  margin-top: -4rem;
  margin-bottom: 2rem;

  & > li {
    margin-bottom: 1rem;
    margin-left: 1em;
    padding-inline-start: 1rem;
  }
}

  @media screen and (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`;

function SignupFormStep1({ onNextStep }) {
  const { config } = useAppContext();
  return (
    <Fragment>
      <StepHeading>{i18n.gettext('Get your restaurant started!')}</StepHeading>
      <FeatureList>
        <li>{i18n.gettext('No risk, no obligations')}</li>
        <li>{i18n.gettext('No payment data necessary')}</li>
      </FeatureList>
      <ActionButton onClick={onNextStep} style={{ width: '100%' }}>
        {i18n.gettext('Register with email')}
      </ActionButton>
      <div style={{ margin: '3rem 0', textAlign: 'center' }}>
        {i18n.gettext('or register with')}
      </div>
      <GoogleButton targetUrl={config.google_signup_url} />
      <AppleButton targetUrl={config.apple_signup_url} />
    </Fragment>
  );
}

SignupFormStep1.propTypes = {
  onNextStep: PropTypes.func,
};

export default SignupFormStep1;
